const validateEmail = (email: string): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
  return emailRegex.test(email)
}

const validateName = (name: string): string | null => {
  if (!name || name.trim().length < 2) {
    return 'Name must be at least 2 characters.'
  }
  return null
}

const validateMessage = (message: string): string | null => {
  if (!message || message.trim().length < 10) {
    return 'Message must be at least 10 characters long.'
  }
  return null
}

export { validateEmail, validateName, validateMessage }
